// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"449":"7d8d534f","451":"c319c39a","469":"6d570219","495":"73d9fa0e","628":"7212b5b6","657":"940601cd","729":"27eca993","731":"becdc4ab"}[chunkId] + ".js";
};